import { collection, onSnapshot, addDoc, doc, deleteDoc, setDoc } from "firebase/firestore";
import { db } from "@/fb.js";
import { config } from "@/utils/configuration/config";
import { getErrorMessageFromFirebaseError } from "@/utils/utils";

export default class ShipPartRepoFirebase {
  async getConfigurationChilds(ship, configurationID, service, collectionConfigurationChild) {
    // console.log("ConfigurationChildsRepoFirebase-getConfigurationChilds", configurationID, collectionConfigurationChild)
    onSnapshot(
      collection(
        db,
        config.firebaseConfig.shipsCollectionName,
        ship.id,
        "ShipConfigurations",
        configurationID,
        collectionConfigurationChild
      ),
      (querySnapshot) => {
        console.log("ConfigurationChildsRepoFirebase-getConfigurationChilds");
        const changes = querySnapshot.docChanges();

        changes.forEach(async (change) => {
          if (change.type === "added") {
            console.log("ShipPartRepoFirebase added", change.doc.id);
            service.addNewShipPartFromRepo(
              ship,
              configurationID,
              collectionConfigurationChild,
              change.doc.id,
              change.doc.data()
            );
          } else if (change.type === "modified") {
            console.log("ShipPartRepoFirebase modified", change.doc.id);
            service.modifyShipPartFromRepo(
              ship,
              configurationID,
              collectionConfigurationChild,
              change.doc.id,
              change.doc.data()
            );
          } else if (change.type === "removed") {
            console.log("ShipPartRepoFirebase removed", change.doc.id);
            service.removedShipPartFromRepo(ship, configurationID, collectionConfigurationChild, change.doc.id);
          }
        });
      }
    );
  }

  saveNewPart(shipId, configurationId, shipPartType, shipPartToSave) {
    console.log("saveNewPart", shipId, configurationId, shipPartType, shipPartToSave);
    var errors = "";
    try {
      addDoc(
        collection(
          db,
          config.firebaseConfig.shipsCollectionName,
          shipId,
          "ShipConfigurations",
          configurationId,
          shipPartType
        ),
        shipPartToSave
      );
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    console.log("ShipRepoFirebase-editShip fin");
    return errors;
  }

  editPart(shipId, configurationId, shipPartType, shipPartToSave) {
    console.log("editNewPart", shipId, configurationId, shipPartType, shipPartToSave.id);
    const partRef = doc(
      db,
      config.firebaseConfig.shipsCollectionName,
      shipId,
      "ShipConfigurations",
      configurationId,
      shipPartType,
      shipPartToSave.id
    );
    var errors = "";
    try {
      setDoc(partRef, shipPartToSave);
    } catch (error) {
      console.log("Error", error);
      errors = getErrorMessageFromFirebaseError(error);
    }

    console.log("ShipRepoFirebase-editShip fin");
    return errors;
  }

  deleteShipPart(shipId, configurationId, shipPartType, shipPartId) {
    console.log("deleteShipPart", shipId, configurationId, shipPartType, shipPartId);
    const shipPartRef = doc(
      db,
      config.firebaseConfig.shipsCollectionName,
      shipId,
      "ShipConfigurations",
      configurationId,
      shipPartType,
      shipPartId
    );
    deleteDoc(shipPartRef);
  }
}
